import React, { useEffect, useState } from 'react';
import {
    Table,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Pagination,
    Typography,
    Box
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import Scrollbar from '../../../Scrollbar';
import CutoffLunchMenuTableHead from './cutoffLunchMenuTableHeader';
import CutoffLunchMenuTableRow from './cutoffLunchMenuTableRow';
import { getCutoffLunchMenuWatcher } from '../../../../redux/actionCreators/admin/cutoffLunchMenu';

const TABLE_HEAD = [
    { id: 'nID', label: 'ID Number', alignRight: false },
    { id: 'CutoffDate', label: 'Date', alignRight: false },
    { id: 'StartTime', label: 'Start Time', alignRight: false },
    { id: 'EndTime', label: 'End Time', alignRight: false },
    { id: 'LunchCount', label: 'Lunch Count', alignRight: false },
    { id: 'UserTypeName', label: 'Type', alignRight: false },
    { id: 'VendorName', label: 'Vendor', alignRight: false },
    { id: 'MenuItemName', label: 'Menu Item', alignRight: false },
    { id: 'ScheduleId', label: 'Source', alignRight: false },
];

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator) {
    const stabilizedThis = array?.map((el, index) => [el, index]);
    stabilizedThis?.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis?.map((el) => el[0]);
}

const CutoffLunchMenuTable = ({ onEdit }) => {

    let firstIndex = 0;

    const dispatch = useDispatch();
    const { CutoffLunchMenuReducers: { cutoffLunchMenuList } } = useSelector((state) => state)

    const [page, setPage] = useState(1);
    // Newest first: scheduled cutoffs add a row every day
    const [order, setOrder] = useState('desc');
    const [orderBy, setOrderBy] = useState('nID');
    const [rowsPerPage] = useState(5);

    useEffect(() => {
        dispatch(getCutoffLunchMenuWatcher())
    }, [dispatch])

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const filteredData = applySortFilter(cutoffLunchMenuList, getComparator(order, orderBy));
    const isNotFound = filteredData?.length === 0;

    return (
        <>
            <Box>
                <Scrollbar>
                    <TableContainer sx={{ minWidth: 600, overflow: 'unset' }}>
                        <Table>
                            <CutoffLunchMenuTableHead
                                order={order}
                                orderBy={orderBy}
                                headLabel={TABLE_HEAD}
                                onRequestSort={handleRequestSort}
                            />
                            <TableBody>
                                {filteredData?.slice(firstIndex + rowsPerPage * (page - 1), rowsPerPage * page)
                                    .map((m) => (
                                        <CutoffLunchMenuTableRow key={`${m.nID}-${m.VendorId}`} rowData={m} onEdit={onEdit} />
                                    ))}
                            </TableBody>
                            {isNotFound && (
                                <TableBody>
                                    <TableRow display='flex'>
                                        <TableCell align="center" colSpan={10} sx={{ py: 3 }}>
                                            <Typography variant='t18_500' >
                                                No records found
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            )}
                        </Table>
                    </TableContainer>
                </Scrollbar>
            </Box>
            <Box spacing={2} display='flex' justifyContent='right' paddingTop='20px' >
                <Pagination
                    shape="rounded"
                    color='primary'
                    count={Math.ceil(cutoffLunchMenuList?.length / rowsPerPage)}
                    page={page}
                    onChange={handleChangePage}
                />
            </Box>
        </>
    )
}

export default CutoffLunchMenuTable;
